import { useState } from "react";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { cn } from "../../../../utils/cn";
import { LoyaltyPointsMenuSection } from "../LoyaltyPointsMenuSection/LoyaltyPointsMenuSection";
import { WalletMenuBalance } from "../WalletMenuBalance/WalletMenuBalance";
import styles from "./WalletPointsTabs.module.scss";

enum WalletPointsTab {
  POINTS = "points",
  WALLET = "wallet",
}

const TABS = [
  { id: WalletPointsTab.POINTS, labelKey: "wallet:points-tab" },
  { id: WalletPointsTab.WALLET, labelKey: "wallet:wallet-tab" },
] as const;

/**
 * The menu's rewards card for a restaurant with a wallet: the points section
 * and the wallet balance behind a Points / Wallet toggle. The card chrome is
 * this component's; the points section drops its own inside `.panel`.
 */
export const WalletPointsTabs = () => {
  const { t } = useTranslationI18();
  const [activeTab, setActiveTab] = useState(WalletPointsTab.POINTS);

  return (
    <div className={styles.card} data-testid="wallet-points-tabs">
      <div className={styles.tab_list} role="tablist">
        {TABS.map(({ id, labelKey }) => (
          <button
            key={id}
            type="button"
            role="tab"
            id={`wallet-points-tab-${id}`}
            aria-selected={activeTab === id}
            aria-controls={`wallet-points-panel-${id}`}
            className={cn(styles.tab, activeTab === id && styles.tab_active)}
            onClick={() => setActiveTab(id)}
            data-testid={`wallet-points-tab-${id}`}
          >
            {t(labelKey)}
          </button>
        ))}
        {/* One bar that slides between the tabs, as on /our-policies. */}
        <span
          aria-hidden
          className={cn(
            styles.tab_indicator,
            activeTab === WalletPointsTab.WALLET && styles.tab_indicator_wallet
          )}
          data-testid="wallet-points-tab-indicator"
        />
      </div>
      <div
        role="tabpanel"
        id={`wallet-points-panel-${activeTab}`}
        aria-labelledby={`wallet-points-tab-${activeTab}`}
        className={styles.wallet_points_panel}
      >
        {activeTab === WalletPointsTab.POINTS ? (
          <LoyaltyPointsMenuSection />
        ) : (
          <WalletMenuBalance />
        )}
      </div>
    </div>
  );
};
